import { Controller, useFormContext } from "react-hook-form";
import { companyOnboardingInputs } from "../helper";
import HelperText from "@components/form/helper-text";

export default function Step2() {
    const { control } = useFormContext()

    return (
        <>
            <div className="mt-1" />
            {companyOnboardingInputs?.[1]?.map(({ name, placeholder, ...input }, idx) => {
                return <div>
                    <Controller
                        name={name}
                        control={control}
                        render={({ field: { value, onChange }, fieldState }) => {
                            return (
                                <>
                                    <input.component
                                        value={value}
                                        onChange={onChange}
                                        placeholder={placeholder}
                                        type={name === "employeeCount" ? "number" : "text"}
                                    />
                                    {fieldState?.error && <HelperText type="danger">{fieldState?.error.message}</HelperText>}
                                </>
                            )
                        }}
                    />

                </div>
            })}
        </>
    );
}